import { motion } from "framer-motion";
import { MANIFESTO, BUSINESS } from "../../data/site";

export const Manifesto = () => {
  return (
    <section id="sobre" data-testid="manifesto-section" className="py-24 md:py-36 bg-cream">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-16 md:mb-24">
          <span className="font-script text-magenta text-3xl md:text-4xl">a nossa promessa</span>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[0.95] mt-2">
            Porque cada patudo merece o melhor.
          </h2>
        </div>

        <div className="border-t border-[#0A0A0A]">
          {MANIFESTO.map((item, idx) => (
            <motion.div
              key={item.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: idx * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="grid grid-cols-12 gap-4 md:gap-8 items-start py-10 md:py-14 border-b border-[#0A0A0A] group"
            >
              <div className="col-span-12 md:col-span-2">
                <span className="font-script text-magenta text-4xl md:text-5xl">{item.n}</span>
              </div>
              <div className="col-span-12 md:col-span-5">
                <h3 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">
                  {item.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="font-body text-base md:text-lg text-[#525252] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 font-body text-sm text-[#525252] max-w-xl">
          Recomendados por famílias em {BUSINESS.location}. Uma equipa que os donos descrevem como
          <span className="text-[#0A0A0A] font-medium"> &ldquo;fora de série&rdquo;</span>.
        </p>
      </div>
    </section>
  );
};
